import keycloakAxios from '@/services/axios';
import {updateGroupInRedux, updateMyGroups} from '@/redux-store/slices/groups';
import {store} from '@/redux-store/store';
import {GroupData} from '@/types/group';
import {emitGroupChangeEvent} from './change-observable';

export const joinGroup = async (groupId: string, userId: string) => {
  const response = await keycloakAxios.get(`group/join/${groupId}`);

  if (response.status >= 300) {
    throw new Error(
      `Error joining the group: Invalid status code: ${response.status}`
    );
  }

  emitGroupChangeEvent({
    type: 'change',
    data: response.data as GroupData
  });

  store.dispatch(updateGroupInRedux(response.data));
  store.dispatch(updateMyGroups({group: response.data, userId}));

  return response.data;
};
